// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3wThQ","name":"Header_name__cF8dQ","birthday":"Header_birthday__1RyzR","skeleton":"Header_skeleton__3YWld"};